export default {
  extendListing: {
    modal: {
      title: "Confirm extend listing expiry",
      description:
        "You’ve selected {count} listing{count, plural, =0 {} =1 {} other{s}} to extend expiry.",
      list: {
        label: "{count} x {label} listing{count, plural, =0 {} =1 {} other{s}}",
        listing:
          "{expend} {isCreditFlattening, select, true {Ad} other {Featured}} credit{expend, plural, =0 {} =1 {} other{s}}",
      },
      summation: {
        deduction: "Total deductions",
        balance: "Balance:",
        credit:
          "{expend} {isCreditFlattening, select, true {Ad} other {Featured}} credit{expend, plural, =0 {} =1 {} other{s}}",
      },
      cancel: "Cancel",
      confirm: "Confirm extend listing expiry",
      message: {
        success: "The listing expiry date has been extended.",
        failed: "Failed to extend. Your listing is not extended.",
      },
    },
  },
};
